import styled from 'styled-components';
import { breakpoints } from '@bnnvara/breakpoints';

export const StatementHeroContainer = styled.div`
  background-color: ${(props) => props.backgroundColor ?? props.theme.base.red};
  color: ${({ theme }) => theme.base.white};
  height: 100%;
  width: 100%;
`;

export const StatementLink = styled.a`
  cursor: pointer;
`;

export const StatementContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  bottom: 24px;
  aspect-ratio: 16 / 9;
  color: ${({ theme }) => theme.base.white}
  gap: 24px;
  ${breakpoints.md} {
    bottom: 48px;
  }

  ${breakpoints.lg} {
    aspect-ratio: auto;
    bottom: 40px;
    gap: 48px;
    height: 520px;
  }
`;

export const Title = styled.p`
  font-size: 2.25rem;
  font-weight: 800;
  text-align: center;
  line-height: 44px;

  ${breakpoints.lg} {
    font-size: 8rem;
    line-height: 140px;
  }
`;

export const Cta = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  text-decoration: underline;
  text-align: center;
  ${breakpoints.lg} {
    font-size: 28px;
    line-height: 36px;
  }
`;
